/** Both columns are `@db.Date`, so the validated inputs and the stored values are UTC midnights. */
export function licenseDatesInOrder(dates) {
    return (!dates.issuedAt || !dates.expiresAt || dates.expiresAt.getTime() >= dates.issuedAt.getTime());
}
//# sourceMappingURL=license-dates-in-order.js.map